<template lang="pug">
.profile-collected-stickers
  .empty-state(v-if="!stickers.length && !loading")
    p No stickers yet. Start collecting!

  .loading-state(v-else-if="loading && !stickers.length")
    el-icon(:size="28" class="loading-spinner")
      Loading
    p Loading stickers...

  .stickers-grid(v-else)
    button.sticker-tile(
      v-for="sticker in stickers"
      :key="sticker.id"
      type="button"
      @click="goToSticker(sticker)"
    )
      img(
        v-if="stickerImage(sticker) && !failedIds[sticker.id]"
        :src="stickerImage(sticker)"
        :alt="sticker.title"
        @error="markFailed(sticker.id)"
      )
      span.placeholder(v-else) {{ sticker.title?.charAt(0) || '?' }}
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from '@element-plus/icons-vue';

export default defineComponent({
  name: 'ProfileCollectedStickersGrid',
  components: { Loading },
  props: {
    stickers: {
      type: Array as () => any[],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const failedIds = reactive<Record<string, boolean>>({});

    function stickerImage(sticker: any) {
      return sticker.thumbnailUrl || sticker.url || sticker.image || '';
    }

    function markFailed(id: string) {
      failedIds[id] = true;
    }

    function goToSticker(sticker: any) {
      const slugOrId = sticker.slug || sticker.id;
      router.push(`/web/sticker/${slugOrId}`);
    }

    return {
      failedIds,
      stickerImage,
      markFailed,
      goToSticker,
    };
  },
});
</script>

<style lang="scss" scoped>
.profile-collected-stickers {
  min-height: 12rem;
}

.stickers-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;

  @media (min-width: 768px) {
    gap: 1rem;
  }
}

.sticker-tile {
  aspect-ratio: 1;
  border-radius: 1rem;
  border: 1px solid #f3f4f6;
  background: #f9fafb;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.15s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

  &:hover {
    transform: scale(1.03);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 1.5rem;
  font-weight: 800;
  color: #9ca3af;
}

.empty-state,
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
  gap: 0.75rem;
  color: #9ca3af;
  font-size: 0.875rem;

  p {
    margin: 0;
  }

  .loading-spinner {
    color: #0d9488;
    animation: spin 1.5s linear infinite;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
